import React from 'react';
import { TableSummaryBySchoolProps, TableSummaryBySchoolData, OlympiadStatus } from '../../model';
import {
  Table,
  Tr,
  Th,
  Td,
  Sort,
  ThContent,
  Tbody,
  Municipality,
  School,
  Regisrations,
  Participants,
  Winners,
  Thead,
  Tfoot,
  TableWrap,
} from './SummaryBySchoolStyled';
import { useSorter } from './hooks';
import TableRowWithTooltip from 'features/shared/TableRowWithTooltip';
import { numberWithSpaces } from 'utils/numberWithSpaces';
import { LogClick, useClickStreamContext } from 'features/shared/ClickStream';
import pluralize from 'utils/pluralize';

const createRow = (
  data: TableSummaryBySchoolData,
  hasOlympiadPassed: boolean,
  isRegionUser: boolean,
  __isRoads221: boolean,
) => {
  return (
    <Tr key={data.municipalicy + data.schoolTitle}>
      <Municipality>
        <TableRowWithTooltip>{data.municipalicy}</TableRowWithTooltip>
      </Municipality>
      {!isRegionUser && (
        <School>
          <TableRowWithTooltip>{data.schoolTitle}</TableRowWithTooltip>
        </School>
      )}
      {!__isRoads221 && <Regisrations>{numberWithSpaces(data.activeStudentsCount || 0)}</Regisrations>}
      <Participants>{numberWithSpaces(data.participantsCount || 0)} </Participants>

      {hasOlympiadPassed && <Winners>{numberWithSpaces(data.prizeholdersCount || 0)} </Winners>}
    </Tr>
  );
};

const TableSummaryBySchool = (props: TableSummaryBySchoolProps) => {
  const total = props.total;
  const { sortRows, ...sortingState } = useSorter(props.rows || [], [
    'municipalicy',
    'activeStudentsCount',
    'participantsCount',
    'prizeholdersCount',
  ]);
  const hasOlympiadPassed = props.status === OlympiadStatus.passed;
  const { logPageEvent } = useClickStreamContext();

  return (
    <TableWrap>
      <Table>
        <Thead>
          <Tr style={{ height: 32 }}>
            <Municipality as={Th} rowSpan={2}>
              <ThContent>
                Муниципалитет/
                <br />
                регион
                <LogClick
                  eventType="olymp_sorting_table"
                  eventInfo="Олимпиада: Сортировка таблицы по полю 'Муниципалитет/регион'"
                  cd1={props.olympiadId}
                >
                  <Sort {...sortingState.municipalicy} />
                </LogClick>
              </ThContent>
            </Municipality>
            {!props.isRegionUser && (
              <School as={Th} rowSpan={2}>
                Школа
              </School>
            )}
            <Th colSpan={hasOlympiadPassed ? 3 : 2}>Ученики</Th>
          </Tr>
          <Tr style={{ height: 48 }}>
            {!props.__isRoads2211 && (
              <Regisrations>
                <ThContent style={{ marginRight: -20, position: 'relative' }}>
                  Занимаются <br />
                  на Учи.ру
                  <LogClick
                    eventType="olymp_sorting_table"
                    eventInfo="Олимпиада: Сортировка таблицы по полю 'Активных на Учи.ру'"
                    cd1={props.olympiadId}
                  >
                    <Sort {...sortingState.activeStudentsCount} />
                  </LogClick>
                </ThContent>
              </Regisrations>
            )}
            <Participants>
              <ThContent>
                <div>Участники</div>
                <LogClick
                  eventType="olymp_sorting_table"
                  eventInfo="Олимпиада: Сортировка таблицы по полю 'Участники'"
                  cd1={props.olympiadId}
                >
                  <Sort {...sortingState.participantsCount} />
                </LogClick>
              </ThContent>
            </Participants>
            {hasOlympiadPassed && (
              <Winners>
                <ThContent>
                  <div>Победители</div>
                  <LogClick
                    eventType="olymp_sorting_table"
                    eventInfo="Олимпиада: Сортировка таблицы по полю 'Победители'"
                    cd1={props.olympiadId}
                  >
                    <Sort {...sortingState.prizeholdersCount} />
                  </LogClick>
                </ThContent>
              </Winners>
            )}
          </Tr>
        </Thead>
        <Tbody>{sortRows.map((el) => createRow(el, hasOlympiadPassed, props.isRegionUser, props.__isRoads2211))}</Tbody>
        <Tfoot>
          <tr>
            <Td colSpan={props.isRegionUser ? 1 : 2} style={{ textAlign: 'right' }}>
              {props.total.realStudentsCount
                ? `Итого, из ${props.total.realStudentsCount} ${pluralize(props.total.realStudentsCount, [
                    'учащегося',
                    'учащихся',
                    'учащихся',
                  ])} муниципалитета:`
                : 'Итого:'}
            </Td>
            {!props.__isRoads2211 && <Regisrations>{numberWithSpaces(total.activeStudentsCount || 0)}</Regisrations>}
            <Participants>{numberWithSpaces(total.participantsCount || 0)} </Participants>
            {hasOlympiadPassed && <Winners>{numberWithSpaces(total.prizeholdersCount || 0)}</Winners>}
          </tr>
        </Tfoot>
      </Table>
    </TableWrap>
  );
};
export default TableSummaryBySchool;
